import {useState, useRef, useEffect, useCallback} from 'react';


const useDebouncedValue = <TValue>(value: TValue, timeout: number) => {
    const [state, setState] = useState(value);

    const updateRef = useRef<boolean>(false);

    const doNotDebounceNextUpdate = useCallback(() => {
        updateRef.current = true;
    }, [updateRef])

    useEffect(() => {
        if (value !== state) {
            if (updateRef.current) {
                updateRef.current = false;
                setState(value);
            }
            else {
                const timerId = window.setTimeout(() => setState(value), timeout);
    
                return () => {
                    window.clearTimeout(timerId);
                }
            }
        }
    }, [state, value, timeout, setState, updateRef])

    return {
        state,
        doNotDebounceNextUpdate
    };
}

export default useDebouncedValue;